import { MDBDatatable, MDBIcon, MDBInput, MDBTextArea } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import PopupLoader from "../../../views/popups/PopupLoader";
import ToggleEditWarning from "../hunt/ToggleEditWarning";
import TextareaAutosize from 'react-textarea-autosize';
import { Tooltip } from "react-tooltip";
import { customSearch } from "../../CustomSearchUtil/CustomSearch";

function LunaVMBox({ voiceMails, vmTextValue, vmError, setvmError, onResetDone }) {
  const [selectAllRadio, setselectAllRadio] = useState("-1");
  const [updateFieldName, setupdateFieldName] = useState("");
  const [updateFieldValue, setupdateFieldValue] = useState("");
  const [toggleValue, settoggleValue] = useState(-1);
  const [columnName, setcolumnName] = useState("");
  const [editWarning, seteditWarning] = useState(false);
  const [vmText, setvmText] = useState({});
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [focusedIndex, setFocusedIndex] = React.useState(null);
  const warningToggle = () => seteditWarning(!editWarning);
  const [searchValue, setSearchValue] = useState(""); // Add search value state
  const [filteredIndices, setFilteredIndices] = useState([]); // Track which indices to show
  const {
    setValue,
    watch,
    control,
    reset,
    clearErrors,
    formState: { errors },
    register,
  } = useFormContext();
  const { fields } = useFieldArray({
    name: "vm.edit_perm",
    control,
  });

  useEffect(() => {
    setSearchValue(""); 
    if (fields && Array.isArray(fields) && fields.length > 0) {
      setFilteredIndices(fields.map((_, index) => index));
    } else {
      setFilteredIndices([]);
    }
  }, [fields.length]);

  useEffect(() => {
    if (voiceMails && voiceMails.length > 0) {
      reset((prev) => ({ ...prev, vm: { ...prev.vm, edit_perm: voiceMails } }));
      onResetDone?.();
    }
  }, [voiceMails]);

  function handleAllChange(feildName, columnName, value) {
    setvmError("");
    clearErrors(`vm.is_perm_enabled`);
    if (value !== "-1") {
      setupdateFieldName(feildName);
      setupdateFieldValue(value);
      seteditWarning(true);
      // setuniqueKeyValue(resetFieldid);
      settoggleValue(value);
      setcolumnName(columnName);
    }
  }

  function handleCloseWarning() {
    setselectAllRadio("-1");
    warningToggle();
  }

  function handleUpdateToggle() {
    fields.forEach((field, index) => {
      setValue(
        `vm.edit_perm.${index}.${updateFieldName}`,
        updateFieldValue ? 1 : 0,
        {
          shouldDirty: true,
        }
      );
    });

    setselectAllRadio("-1");
    warningToggle();
  }

  useEffect(() => {
    if (vmTextValue && Object.entries(vmTextValue).length > 0) {
      setvmText(vmTextValue);
    }
  }, [vmTextValue]);

  useEffect(() => {
    // Cleanup function to clear timeout when component unmounts or input value changes
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
    };
  }, [typingTimeout]);

  function handleInfoChange(index, ext, value) {
    setvmText((prev) => ({ ...prev, [ext]: value }));
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    const newTimeout = setTimeout(() => {
      setValue(`vm.edit_perm.${index}.info`, value, {
        shouldDirty: true,
      });
      clearErrors(`vm.is_perm_enabled`);
    }, 1000);
    setTypingTimeout(newTimeout);
  }

  const handleSearch = (value) => {
    setSearchValue(value); // <--- add this

    // Safety check for fields array
    if (!fields || fields.length === 0) {
      setFilteredIndices([]);
      return;
    }
    
    if (!value.trim()) {
      // Show all items when search is cleared
      setFilteredIndices(fields.map((_, index) => index));
      return;
    }
    
    // Use your existing customSearch method
    const filterResult = customSearch(fields, value, ["name", "ext"]);
    
    // Find indices of filtered results in original fields array
    const matchingIndices = filterResult.map(filteredItem => 
      fields.findIndex(field => 
        field && ( // Add safety check for field existence
          field.id === filteredItem.id || 
          (field.name === filteredItem.name && field.ext === filteredItem.ext)
        )
      )
    ).filter(index => index !== -1);
    
    setFilteredIndices(matchingIndices);
  };


  let processdrows = [];
  if (fields && fields.length > 0 && filteredIndices.length > 0) {

    // fields.map((vm, index) => {
      filteredIndices.forEach((originalIndex) => {
        const vm = fields[originalIndex];
        
        // Additional safety check for the individual field object
        if (!vm || typeof vm !== 'object') return;       

    const isFocused = focusedIndex === originalIndex;
    processdrows.push({
      vmInfo: vm,
      name: vm.name,
      extension: vm.ext,
      information: (
        <>
          {watch(`vm.edit_perm.${originalIndex}.flag`) === 1 ? (
            <div className={`position-relative ${isFocused ? "" : "no-scrollbar-textarea"}`}>
              <TextareaAutosize
                minRows={isFocused ? 8 : 3}
                maxRows={isFocused ? 8 : 3}
                className="w-100"
                type="text"
                maxLength={500}
                // value={vmText[vm.ext] || ""}
                {...register(`vm.edit_perm.${originalIndex}.info`)}
                onFocus={() => setFocusedIndex(originalIndex)}
                onBlur={(e) => {
                  // Check if the related target is the toggle switch
                  const relatedTarget = e.relatedTarget;
                  if (relatedTarget && relatedTarget.closest('.phoneselect')) {
                    return; // Don't blur if clicking on the toggle
                  }
                  setFocusedIndex(null);
                }}
                onChange={(e) => {
                  setvmError("");
                  setValue(`vm.edit_perm.${originalIndex}.info`, e.target.value, {
                    shouldDirty: true,
                  });
                  clearErrors(`vm.is_perm_enabled`);
                  // handleInfoChange(index, vm.ext, e.target.value);
                }}
              />
              <div
                className="  text-muted text-end lh-normal pe-1 pb-1 "
                style={{
                  fontSize: "10.5px",
                  pointerEvents: "none"
                }}
              >
                {watch(`vm.edit_perm.${originalIndex}.info`)?.length || 0}/500
              </div>
            </div>
          ) : (
            ""
          )}
        </>
      ),
      active: (
        <>
          <div className="d-flex align-items-center flex-column justify-content-center">
            <div className="phoneselect">
              <label className="switch">
                <input
                  className="form-control"
                  type="checkbox"
                  checked={watch(`vm.edit_perm.${originalIndex}.flag`) === 1}
                  onChange={(e) => {
                    setvmError("");
                    setValue(
                      `vm.edit_perm.${originalIndex}.flag`,
                      e.target.checked ? 1 : 0,
                      { shouldDirty: true }
                    );
                  }}
                  name="DefualtLocation"
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </>
      ),
    });
  });
}

  const VMBox = {
    columns: [
      {
        label: (
          <>
            Name
          </>
        ),
        field: "name",
      },
      {
        label: (
          <>
            Extension
          </>
        ),
        field: "extension",
      },
      ,
      {
        label: (
          <>
            <div className="fw-bold">Information <MDBIcon icon="info-circle" className="ms-3 vmVox_info" /></div>
          </>
        ),
        field: "information",
        sort: false,
      },
      {
        label: (
          <>
            <div className="d-flex align-items-center flex-column justify-content-center">
              <p className="fw-bold">Active</p>

              {/* <div className="three-checkbox round2 mx-0">
                <input
                  type="radio"
                  name="ActiveValue13 "
                  checked={selectAllRadio === false}
                  onChange={(e) => {
                    if (e) {
                      setselectAllRadio(false);
                      handleAllChange("flag", "Active", false);
                    }
                  }}
                />
                <input
                  type="radio"
                  name="ActiveValue13 "
                  checked={selectAllRadio === "-1"}
                  onChange={(e) => {
                    if (e) {
                      setselectAllRadio("-1");
                      handleAllChange("flag", "Active", "-1");
                    }
                  }}
                />
                <input
                  type="radio"
                  name="ActiveValue13 "
                  checked={selectAllRadio === true}
                  onChange={(e) => {
                    if (e) {
                      setselectAllRadio(true);
                      handleAllChange("flag", "Active", true);
                    }
                  }}
                />
                <span className="slider"></span>
              </div> */}
            </div>
          </>
        ),
        field: "active",
        sort: false,
      },
    ],
    rows: processdrows,
  };

  return (
    <>
      <div className="section-content">
        <div className="d-flex align-items-center justify-content-between mb-3 pe-4">
          <div className="general-settings m-0">VM Box</div>
          <div className="phoneselect">
            <label className="switch">
              <input
                className="form-control"
                type="checkbox"
                name="DefualtLocation"
                value={watch(`vm.is_perm_enabled`)}
                checked={watch(`vm.is_perm_enabled`)}
                onChange={(e) => {
                  setvmError("");
                  clearErrors(`vm.is_perm_enabled`);
                  setValue(`vm.is_perm_enabled`, e.target.checked, {
                    shouldDirty: true,
                  });
                }}
              />
              <span className="slider round"></span>
            </label>
            {errors?.vm?.is_perm_enabled && (
              <p className="text-danger">
                {errors?.vm?.is_perm_enabled?.message}
              </p>
            )}
          </div>
        </div>
        {vmError && <p className="text-danger">{vmError}</p>}
        {watch("vm.is_perm_enabled") && (
          <>
            <div className="actionbar"></div>
                <div className='mb-2 mt-0 position-relative w-auto'>
                                      <MDBInput
                                        label="Search"
                                        value={searchValue}
                                        onChange={(e) => handleSearch(e.target.value)}
                                      />
                                      <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                                    </div>
            <MDBDatatable
              className="actioncolumn LunaVMBoxDataTable"
              key={searchValue}
              // pagination={false}
              // search
              fixedHeader
              hover
              data={VMBox}
            />
          </>
        )}
      </div>
      {editWarning && (
        <PopupLoader
          size="md"
          title="Warning"
          content={
            <ToggleEditWarning
              handleUpdateToggle={handleUpdateToggle}
              handleCloseWarning={handleCloseWarning}
              toggleValue={null}
              columnName={columnName}
              isLuna={true}
            />
          }
          onShow={seteditWarning}
          onClose={handleCloseWarning}
        />
      )}
      <Tooltip anchorSelect=".vmVox_info" place="top" className="exampleTooltipLight">
        Tells Luna what each active VM Box is Used for.
      </Tooltip>

    </>
  );
}

export default React.memo(LunaVMBox);
